export default (function (o) {
  return o !== undefined && o !== null && typeof o.then === 'function';
});